import {useAsync2} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {Link} from "react-router-dom";
import {projectLabel} from "../../../../api/Projects";

export function DiscontinuedProductProjectList(props: {
    product: number;
}) {
    const list = useAsync2((input) => api.products.listProjectUsage(input),
        {product: props.product},
        [props.product])

    return (
        <>
            {list.LoadingOrErrorElement}
            <ul>
            {list.asList.map(l => (
                <li><Link to={`/project/${l.project}`}>{projectLabel({projectNumber: l.projectNumber, name: l.projectName})}</Link></li>
            ))}
            </ul>
        </>
    )
}